var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dsf-dropdown-wrapper", {
    ref: "dropdownWrapper",
    staticClass: "el-select dsf-tree-dropdown",
    attrs: { width: _vm.width, height: "380px" },
    on: { "visible-change": _vm.visibleChange },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function () {
            return [
              _vm.multiple
                ? _c(
                    "div",
                    { ref: "tags", staticClass: "el-select__tags" },
                    [
                      _vm.collapseTags && _vm.selectedValue.length
                        ? _c(
                            "span",
                            [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    closable: !_vm.disabled,
                                    size: _vm.collapseTagSize,
                                    type: "info",
                                    "disable-transitions": "",
                                  },
                                  on: {
                                    close: function ($event) {
                                      return _vm.deleteTag(
                                        $event,
                                        _vm.selectedValue[0],
                                        0
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "el-select__tags-text" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.selectedValue[0].currentLabel
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm.selectedValue.length > 1
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        closable: false,
                                        size: _vm.collapseTagSize,
                                        type: "info",
                                        "disable-transitions": "",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "el-select__tags-text" },
                                        [
                                          _vm._v(
                                            "+ " +
                                              _vm._s(
                                                _vm.selectedValue.length - 1
                                              )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _c(
                            "transition-group",
                            { on: { "after-leave": _vm.resetInputHeight } },
                            _vm._l(_vm.selectedValue, function (item, i) {
                              return _c(
                                "el-tag",
                                {
                                  key: item.value,
                                  attrs: {
                                    closable: !_vm.disabled,
                                    size: _vm.collapseTagSize,
                                    type: "info",
                                    "disable-transitions": "",
                                  },
                                  on: {
                                    close: function ($event) {
                                      return _vm.deleteTag($event, item, i)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "el-select__tags-text" },
                                    [_vm._v(_vm._s(item.text))]
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                      _vm.filterable
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.query,
                                expression: "query",
                              },
                            ],
                            ref: "input",
                            staticClass: "el-select__input",
                            class: [
                              _vm.selectSize ? "is-" + _vm.selectSize : "",
                            ],
                            style: {
                              "flex-grow": "1",
                              width:
                                _vm.inputLength / (_vm.inputWidth - 32) + "%",
                              "max-width": _vm.inputWidth - 42 + "px",
                            },
                            attrs: {
                              type: "text",
                              disabled: _vm.selectDisabled,
                              autocomplete:
                                _vm.autoComplete || _vm.autocomplete,
                            },
                            domProps: { value: _vm.query },
                            on: {
                              focus: _vm.handleFocus,
                              blur: function ($event) {
                                _vm.softFocus = false
                              },
                              keyup: _vm.managePlaceholder,
                              keydown: [
                                _vm.resetInputState,
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "down",
                                      40,
                                      $event.key,
                                      ["Down", "ArrowDown"]
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.handleNavigate("next")
                                },
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "up",
                                      38,
                                      $event.key,
                                      ["Up", "ArrowUp"]
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.handleNavigate("prev")
                                },
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.selectOption.apply(null, arguments)
                                },
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "esc",
                                      27,
                                      $event.key,
                                      ["Esc", "Escape"]
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  _vm.visible = false
                                },
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "delete",
                                      [8, 46],
                                      $event.key,
                                      ["Backspace", "Delete", "Del"]
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.deletePrevTag.apply(
                                    null,
                                    arguments
                                  )
                                },
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "tab",
                                      9,
                                      $event.key,
                                      "Tab"
                                    )
                                  ) {
                                    return null
                                  }
                                  _vm.visible = false
                                },
                              ],
                              compositionstart: _vm.handleComposition,
                              compositionupdate: _vm.handleComposition,
                              compositionend: _vm.handleComposition,
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.query = $event.target.value
                                },
                                _vm.debouncedQueryChange,
                              ],
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-input",
                {
                  ref: "reference",
                  class: { "is-focus": _vm.visible },
                  attrs: {
                    placeholder: _vm.currentPlaceholder,
                    name: _vm.name,
                    id: _vm.id,
                    autocomplete: _vm.autocomplete,
                    size: _vm.selectSize,
                    disabled: _vm.selectDisabled,
                    "validate-event": false,
                    tabindex: _vm.multiple ? "-1" : null,
                    type: "text",
                    readonly: "",
                  },
                  on: {
                    focus: _vm.handleFocus,
                    blur: _vm.handleBlur,
                    compositionstart: _vm.handleComposition,
                    compositionupdate: _vm.handleComposition,
                    compositionend: _vm.handleComposition,
                  },
                  nativeOn: {
                    keydown: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "esc", 27, $event.key, [
                            "Esc",
                            "Escape",
                          ])
                        ) {
                          return null
                        }
                        $event.stopPropagation()
                        $event.preventDefault()
                        _vm.visible = false
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                        ) {
                          return null
                        }
                        _vm.visible = false
                      },
                    ],
                    mouseenter: function ($event) {
                      _vm.inputHovering = true
                    },
                    mouseleave: function ($event) {
                      _vm.inputHovering = false
                    },
                  },
                  model: {
                    value: _vm.selectedValue.text,
                    callback: function ($$v) {
                      _vm.$set(_vm.selectedValue, "text", $$v)
                    },
                    expression: "selectedValue.text",
                  },
                },
                [
                  _vm.$slots.prefix
                    ? _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2)
                    : _vm._e(),
                  _c("template", { slot: "suffix" }, [
                    _c("i", {
                      class: [
                        "el-select__caret",
                        "el-input__icon",
                        "el-icon-" + _vm.iconClass,
                      ],
                    }),
                    _vm.showCloseCopy
                      ? _c("i", {
                          staticClass:
                            "el-select__caret el-input__icon el-icon-circle-close",
                          on: { click: _vm.handleClearClick },
                        })
                      : _vm._e(),
                  ]),
                ],
                2
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "dropdown",
          fn: function () {
            return [
              _c("dsf-tree-select", {
                ref: "tree",
                attrs: {
                  "tree-data": _vm.options,
                  loading: _vm.treeLoading,
                  "default-checked-key": _vm.dictRmId,
                  "get-no-check": _vm.getNoCheck,
                  multiple: _vm.multiple,
                  "check-strictly": _vm.checkStrictly,
                  "node-key": "_id",
                  "node-name": "_name",
                  "node-children": "children",
                  "search-control": "",
                  "default-expand-all": "",
                },
                on: { "choose-node": _vm.chooseNode },
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }